var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("v-card", { attrs: { hover: "" } }, [
    _c(
      "div",
      { staticStyle: { display: "flex", "justify-content": "space-between" } },
      [
        _c(
          "div",
          {
            on: {
              click: function ($event) {
                return _vm.showDetail()
              },
            },
          },
          [
            _c("v-card-text", [
              _c("h3", { staticClass: "headline mb-0" }, [
                _vm._v("NUM. DDT: " + _vm._s(_vm.spedizione.numeroDDT)),
              ]),
              _c("div", { staticClass: "text-truncate" }, [
                _vm._v("DATA DDT: "),
                _c("strong", [_vm._v(_vm._s(_vm.spedizione.dataDDT))]),
              ]),
              _c("div", { staticClass: "text-truncate" }, [
                _vm._v("DATA CREAZIONE: "),
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.formatDate(_vm.spedizione.dataOraCreazione))
                  ),
                ]),
              ]),
            ]),
            _c("v-card-text", [
              _c("div", { staticClass: "text-truncate" }, [
                _vm._v("MITTENTE: "),
                _c("strong", [
                  _vm._v(_vm._s(_vm.spedizione.ragioneSocialeMittente)),
                ]),
              ]),
              _c("div", { staticClass: "text-truncate" }, [
                _vm._v("DESTINATARIO: "),
                _c("strong", [
                  _vm._v(_vm._s(_vm.spedizione.ragioneSocialeDestinatario)),
                ]),
              ]),
              _c("div", { staticClass: "text-truncate" }, [
                _vm._v("NUMERO COLLI: "),
                _c("strong", [_vm._v(_vm._s(_vm.spedizione.numeroColli))]),
              ]),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "card-actions" },
          [
            _c(
              "v-btn",
              {
                staticStyle: { margin: "15px" },
                attrs: { icon: "", ripple: "" },
                on: {
                  click: function ($event) {
                    return _vm.setIdSpedizioneForDelete(_vm.spedizione.id)
                  },
                },
              },
              [
                _c(
                  "v-icon",
                  { attrs: { size: "25", color: "grey lighten-1" } },
                  [_vm._v("mdi-delete")]
                ),
              ],
              1
            ),
            _vm.spedizione.note && _vm.spedizione.note.length > 0
              ? _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "v-icon",
                                _vm._g(
                                  {
                                    staticClass: "ico-stato",
                                    attrs: {
                                      slot: "activator",
                                      size: "40",
                                      color: "yellow darken-1",
                                      dark: "",
                                    },
                                    slot: "activator",
                                  },
                                  on
                                ),
                                [_vm._v("mdi-note")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1003709103
                    ),
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.spedizione.note))])]
                )
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }